<template>
  <transition name="fade">
    <div class="notification" v-if="visible">
      <p>{{ message }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Notification",
  props: {
    message: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      visible: true,
    };
  },
  mounted() {
    setTimeout(() => {
      this.visible = false;
      this.$emit('close');
    }, 3000);
  },
};
</script>

<style scoped>
.notification {
  position: fixed;
  top: 20px;
  right: 20px;
  padding: 10px;
  background-color: #28a745;
  color: white;
  border-radius: 4px;
  z-index: 4000;
  transition: opacity 0.3s ease;
}
.notification.info {
  background-color: #007bff;
}

.notification.success {
  background-color: #28a745;
}

.notification.error {
  background-color: #dc3545;
}
.notification p {
  margin: 0;
  font-size: 1rem;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
